import React from "react";

import { faGlobe } from "@fortawesome/pro-light-svg-icons/faGlobe";
import { faUsers } from "@fortawesome/pro-solid-svg-icons/faUsers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "antd/es/card";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import BaseStepProps from "@app/scene/auth/component/Register/types/BaseStepProps";
import InvitationInfo from "@app/types/auth/InvitationInfo";

import styles from "./InvitationInfoStep.module.scss";

interface Props extends BaseStepProps {
  className?: string;
  info: InvitationInfo;
}

const InvitationInfoStep = ({ className, info, onNextClick }: Props) => {
  const intl = useIntl();
  return (
    <div className={cn(styles.container, className)}>
      <Card>
        <p className={styles.line1} data-action-id="invitation-inviter-info">
          {intl.formatMessage(
            {
              id: "auth.registerMember.invitationInfoStep.line1",
              defaultMessage: "{owner} has invited you to Map My Customers",
              description: "First line of info in Invitation Info step of Register Member page",
            },
            {
              owner: info.ownerName,
            }
          )}
        </p>
        <p className={styles.line2} data-action-id="invitation-org-name">
          <FontAwesomeIcon className={styles.icon} icon={faGlobe} />
          {info.organizationName}
        </p>
        {info.teamNames.map((teamName, index) => (
          <p className={styles.line3} key={index}>
            <FontAwesomeIcon className={styles.icon} icon={faUsers} />
            {teamName}
          </p>
        ))}
      </Card>
      <Button block onClick={onNextClick} type="primary">
        {intl.formatMessage({
          id: "auth.registerMember.invitationInfoStep.buttonNext",
          defaultMessage: "Set up my account",
          description: "Next button in Invitation Info step of Register Member page",
        })}
      </Button>
    </div>
  );
};

export default InvitationInfoStep;
